import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ihcmlcnktfrrojtkrtbt.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImloY21sY25rdGZycm9qdGtydGJ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzIzNjg5OTIsImV4cCI6MjA0Nzk0NDk5Mn0.wltMxH7P0MBkt-DXEcaE0Uqye_MKUhz6h4Rzrk76dyE';

export const supabase = createClient(supabaseUrl, supabaseKey);